import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageview } from "@/lib/analytics";

// ============================================================
// FYUNOR — Analytics Tracker
// Fires a GA4 page_view on every route change (including the
// initial load). Placed inside <Router> so useLocation works.
// ============================================================

export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    pageview(pathname + search);
  }, [pathname, search]);

  return null;
}